document.addEventListener('DOMContentLoaded', function() {
    const hideMenuSearch = () => {
        Array.from(document.getElementsByClassName("nav-search")).forEach((item) => item.hidden = true )
    }
    const pagesLinkIsVisible = () => {
        return Boolean(Array.from(document.querySelectorAll("nav.nav-main li")).filter((item) => item.textContent.trim() == "Pages").length)
    }

    if(!pagesLinkIsVisible()) {
        setTimeout(hideMenuSearch, 1)
    }
})
